// Shared "Chargement..." placeholder - spinner + text, see .spinner in
// styles/base.css for the actual CSS ring (no image/icon-font asset, just
// a bordered circle animated with a plain @keyframes rotation). One
// constant so every route/section that fetches before it has anything
// real to show (Album/Artist/Library/Playlist/Series's own route entry,
// Home's per-library carousels) renders the exact same markup instead of
// each hand-typing a slightly different one - a plain-text .hide/.hint
// mismatch is exactly the kind of drift a shared constant avoids.
//
// The sidebar's own library list (Shell.html) and Player.ts's video-
// buffering notice (Player.html's #loadingNotice) don't use this: the
// sidebar's markup is a static template with no JS import of its own
// (see Shell.html directly - same spinner markup, just pasted once by
// hand instead of imported), and the video notice is already a distinct,
// separately-styled centered overlay with its own text ("Chargement du
// flux..."), not a plain in-flow <p class="hint">.
export const LOADING_HINT = '<p class="hint"><span class="spinner"></span>Chargement...</p>';
